/*
 * @Author: 郭洪宇 guohongyu@chinasofti.com
 * @Date: 2022-07-18 13:59:51
 * @LastEditors: ghy
 * @LastEditTime: 2023-08-09 14:15:00
 * @FilePath: \cigbus-vue-cdp-ma\src\api\objectRelationshipManage.js
 * @Description: 
 */
import axios from './index'
export const API_MAIN = '/api'

/**
 * @description: 公告列表
 * 
 * @param {
 * }
 * @return {*}
 */
export const findCheckedNoticePage = (data) => {
    return axios.request({
        url: `${API_MAIN}/findCheckedNoticePage`,
        method: 'post',
        data
    })
}
export const findNoticeDetail = (data) => {
    return axios.request({
        url: `${API_MAIN}/findNoticeDetail`,
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/notice.js